export function PlusGradientIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.66668 3.99967C8.66668 3.63148 8.3682 3.33301 8.00001 3.33301C7.63182 3.33301 7.33334 3.63148 7.33334 3.99967L7.33334 7.33301H4.00001C3.63182 7.33301 3.33334 7.63148 3.33334 7.99967C3.33334 8.36786 3.63182 8.66634 4.00001 8.66634H7.33334L7.33334 11.9997C7.33334 12.3679 7.63182 12.6663 8.00001 12.6663C8.3682 12.6663 8.66668 12.3679 8.66668 11.9997V8.66634H12C12.3682 8.66634 12.6667 8.36786 12.6667 7.99967C12.6667 7.63148 12.3682 7.33301 12 7.33301H8.66668L8.66668 3.99967Z"
        fill="url(#paint0_linear_12524_34586)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12524_34586"
          x1="1.97223"
          y1="7.99967"
          x2="19.0056"
          y2="7.99967"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.142579" stopColor="#176984" />
          <stop offset="0.94179" stopColor="#64CCC5" />
        </linearGradient>
      </defs>
    </svg>
  );
}
